import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"


export function useHorizontalSigns(parameters = {}, config = {}) {
    const url = "horizontal_signs/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = horizontalSigningQueryKeys["layer"](queryParameters)

    return useHorizontalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}

export const useExistingHorizontalSign = (signId, onError) => {

    const queryClient = useQueryClient()
    const signQueryKey = horizontalSigningQueryKeys["feature"](signId)
    signQueryKey.pop()
    const layerQueryKey = horizontalSigningQueryKeys["layer"]()
    layerQueryKey.pop()

    const signsDataFromLayer = queryClient.getQueriesData({ queryKey: layerQueryKey })
    const signsData = queryClient.getQueriesData({ queryKey: signQueryKey })

    const existingInSignData = signsData?.some(([_, signData]) => {
        return (signData?.id || signData?.uuid) === signId
    })
    const existingInLayerData = signsDataFromLayer?.some(([_, signsDataFromLayer]) => {
        if (signsDataFromLayer?.features) {
            return signsDataFromLayer?.features?.some(sign => {
                return sign.id === signId
            })
        } else {
            return signsDataFromLayer?.some(sign => sign.uuid === signId)
        }
    })
    const existingSignInCache = existingInSignData || existingInLayerData

    const { isLoading, isError } = useHorizontalSign(signId, {}, {
        enabled: !existingSignInCache,
        onError,
    })

    return (!(isLoading || isError) || existingSignInCache)
}

export function useHorizontalSign(signId, parameters = {}, config = {}) {
    const url = `horizontal_signs/${signId}/`
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = horizontalSigningQueryKeys["feature"](signId, parameters)

    return useHorizontalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            autoRefetch: true,
            ...config,
        },
    )
}